import SeoHead from "@/components/SeoHead";
import { Link } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { ArrowLeft } from "lucide-react";
import RefundPolicyContent from "./legal/RefundPolicyContent";

/**
 * Stripe 合规必需页面 — 独立的退款与取消政策页面。
 * 正文复用 RefundPolicyContent（/legal 合并页也用同一组件）。
 */
export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SeoHead
        path="refund"
        title="Refund & Cancellation Policy - BamaBang"
        description="BamaBang refund and cancellation policy. Learn about our refund terms for subscriptions and digital purchases."
      />

      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center text-gray-600 hover:text-pink-600 transition"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            <span className="font-medium hidden sm:inline">Back</span>
          </Link>
          <div className="flex items-center gap-3">
            <img src="/favicon.png" alt="Logo" className="w-10 h-10" />
            <h1 className="font-bold text-gray-900 text-lg hidden sm:block">
              BamaBang
            </h1>
          </div>
          <LanguageSwitcher />
        </div>
      </header>

      {/* Content — 复用 RefundPolicyContent */}
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 py-12">
        <RefundPolicyContent />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-10 px-4 mt-12">
        <div className="max-w-3xl mx-auto text-center">
          <img
            src="/favicon.png"
            alt="Logo"
            className="w-10 h-10 mx-auto mb-4 opacity-50 grayscale"
          />
          <p className="text-sm">© 2026 bamabang.net. All rights reserved.</p>
          <div className="mt-3 flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/privacy" className="hover:text-white transition">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition">
              Terms of Service
            </Link>
            <Link to="/refund" className="hover:text-white transition font-semibold">
              Refund Policy
            </Link>
            <Link to="/support" className="hover:text-white transition">
              Support
            </Link>
          </div>
          <p className="mt-4 text-xs">
            Contact Us: bamabang.info@gmail.com
          </p>
          <p className="mt-2 text-xs text-gray-500">
            Service restricted to 18+. Registration requires age verification.
          </p>
        </div>
      </footer>
    </div>
  );
}
